import React from 'react'
import type { InventoryBySerialNumberProviderProps } from './Context'
import { InventoryBySerialNumberListProvider } from './Context'
import { Layout } from './Layout'

export const InventoryBySerialNumberList = (props: Omit<InventoryBySerialNumberProviderProps, 'children'>) => {
  return (
    <InventoryBySerialNumberListProvider {...props}>
      <Layout />
    </InventoryBySerialNumberListProvider>
  )
}
